<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{ $t('Tarixdən') }}</label>
        <el-date-picker size="small" id="starDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{ $t('Tarixədək') }}</label>
        <el-date-picker size="small" id="endDate" format="dd.MM.yyyy" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-6">
        <label>{{ $t('Axtarış_növü') }}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 120%" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('SŞ_nömrəsi')" :value="2"></el-option>
              <el-option :label="$t('DQN')" :value="3"></el-option>
              <el-option :label="$t('Çağrı_mərkəzi_Məsul_şəxs')" :value="5"></el-option>
              <el-option :label="$t('Komissar_Məsul_şəxs')" :value="4"></el-option>
              <el-option :label="$t('Müştəri_xidməti_Məsul_şəxs')" :value="6"></el-option>
              <el-option :label="$t('İştirakçılar')" :value="7"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" :placeholder="$t('Axtar')" @keyup.enter.native="clickSearch"
              :disabled="item.searchType == 0" v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>

            &nbsp;
            <el-button size="small" type="primary" icon="el-icon-search" @click="clickSearch"></el-button>
            &nbsp;
            <download-excel ref="excel" :fields="cells" :data="exportDataList" worksheet="My Worksheet"
              name="responses">
              <el-button size="small" type="info" @click.stop.prevent="exportData">
                <i class="fa-solid fa-download"></i> {{ $t('Export') }}
              </el-button>
            </download-excel>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8 col-12" style="margin-left: -15px;">
      <el-checkbox @change="getData" v-model="item.commFinish">{{ $t('Komissar_tərəfindən_iş_bağlanıb') }}</el-checkbox>
    </div>
    <div class="row">
      <div class="col-12">
        <el-table ref="elTable" v-loading="loading" :data="displayData" style="width: 100%">
          <!-- <el-table-column :label="$t('Status')" width="300">
            <template slot-scope="scope">
              <status-label :type="scope.row.statusTypeId === 5 ? 'mediumBlue' : '' ||
              scope.row.statusTypeId === 10
              ? 'forestGreen' : ''" />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Sığorta_növü')" prop="policyTypeName" width="300">
          </el-table-column>
          <el-table-column :label="$t('Komissar')" prop="accidentCommUserName" width="200">

          </el-table-column>
          <el-table-column :label="$t('Çıxış_olub')" width="100">
            <template slot-scope="scope">
              <input type="checkbox" :checked="scope.row.needDeparture" />
            </template>
          </el-table-column>
          <el-table-column :label="$t('Rayon')" prop="regionName" width="150">
          </el-table-column>
          <!-- <el-table-column sortable :label="$t('Hadisəyə_çıxış_vaxtı')" prop="departureDateStr" width="200">
          </el-table-column>
          <el-table-column :label="$t('Hadisədən_ayrılma_vaxtı')" prop="leaveDateStr" width="200">
          </el-table-column>
          <el-table-column :label="$t('Hadisənin_bağlanma_tarixi')" prop="finishDateStr" width="250">
          </el-table-column>
          <el-table-column :label="$t('Hadisənin_bağlanma_səbəbi')" prop="finishReasonName" width="250">
          </el-table-column>
          <el-table-column :label="$t('Hadisənin_bağlanma_qeydləri')" prop="finishNote" width="300">
          </el-table-column>
          <el-table-column :label="$t('NV_sayı')" prop="vehicleCount" width="150">
          </el-table-column>
          <el-table-column :label="$t('Təfərrüat')" prop="departureResult" width="300">
          </el-table-column> -->
          <el-table-column :label="$t('Çağrı_mərkəzi_məsul_şəxs')" prop="createUserName" width="200">
          </el-table-column>
          <el-table-column :label="$t('Zəng_tarixi')" sortable prop="callDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Hadisə_tarixi')" prop="accidentDateStr" width="150">
          </el-table-column>
          <!-- <el-table-column :label="$t('Zəng_edən_şəxs')" prop="callPerson" width="150">
          </el-table-column> -->
          <!-- <el-table-column :label="$t('Zəng_edən_şəxsin_nömrəsi')" prop="callPhone" width="200">
          </el-table-column> -->
          <!-- <el-table-column :label="$t('Zəng_qeydlər')" prop="callNotes" width="150">
          </el-table-column> -->
          <el-table-column :label="$t('Hadisə_yeri')" prop="place" width="300">
          </el-table-column>
          <el-table-column :label="$t('Növ')" prop="personTypeName" width="100">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı_adı')" prop="insuredName" width="200">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı_nömrəsi')" sortable prop="phone" width="150">
          </el-table-column>
          <el-table-column :label="$t('SŞ_nömrəsi')" prop="policyNumber" width="150">
          </el-table-column>
          <el-table-column :label="$t('Nəqliyyat_vasitəsi')" prop="brandModel" width="150">
          </el-table-column>
          <el-table-column :label="$t('DQN')" prop="regNumber" width="100">
          </el-table-column>
          <el-table-column :label="$t('SŞ_Başlama_tarixi')" prop="startDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('SŞ_Bitmə_tarixi')" prop="endDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Qeydlər')" prop="descr" width="500">
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleEdit(scope.row.accidentId)" style="padding: 0 !important">
                <div class="square-icon"> <i :title="$t('Hadisəyə_keçid')" class="fa-solid fa-up-right-from-square"></i></div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleStatusView(scope.row.accidentId, 'accident')" style="padding: 0 !important">

                <div class="square-icon"> <i :title="$t('Ümumi_Statuslar')" class="fa-solid fa-timeline"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>
    <accident-view ref="accident" />
    <accident-status-view ref="status" />
  </div>
</template>

<script>
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import { GetCommAllAccidents } from "src/services/common";
import AccidentView from "./AccidentView.vue";
// import StatusLabel from "../components/StatusLabel.vue";
import AccidentStatusView from "../components/AccidentStatusView.vue";

export default {
  components: {
    AccidentView,
    // StatusLabel,
    AccidentStatusView
  },
  data() {
    return {
      mydata: false,
      loading: false,
      data: [],
      totalRecords: 0,
      search: "",
      item: {
        startDate: null,
        endDate: null,
        searchType: 0,
        searchText: null,
        commFinish: false,
        pageSize: 10,
        pageNumber: 1,
        dataExport: 0
      },
      displayData: [],
      exportDataList: [],
      filter: {
        page: 1,
        pagesize: 10,
      },
      cells: {
          'Status': 'statusTypeName',
        'Hadisə #"': 'dispAccidentNumber',
        'Komissar': 'mainAccidentCommUserName',
        'Çıxış olub': 'needDepartureName',
        'Rayon': 'regionName',
        'Hadisəyə çıxış vaxtı': 'departureDateStr',
        'Hadisədən ayrılma vaxtı': 'leaveDateStr',
        'Hadisənin bağlanma tarixi': 'finishDateStr',
        'Hadisənin bağlanma səbəbi': 'finishReasonName',
        'Hadisənin bağlanma qeydləri': 'finishNote',
        'NV sayı': 'vehicleCount',
        'Çağrı mərkəzi məsul şəxs': 'createUserName',
        'Zəng tarixi': 'callDateStr',
        'Hadisə tarixi': 'accidentDateStr',
        'Zəng edən şəxs': 'callPerson',
        'Zəng edən şəxsin nömrəsi': 'callPhone',
        'Zəng edən şəxsin nömrəsi': 'callPhone',
        'Zəng qeydlər': 'callNotes',
        'Hadisə yeri': 'place',
        'Növ': 'personTypeName',
        'Sığortalı adı': 'insuredName',
        'Sığortalı nömrəsi': 'phone',
        'SŞ nömrəsi': 'policyNumber',
        'Nəqliyyat vasitəsi': 'brandModel',
        'DQN': 'regNumber',
        'SŞ Başlama tarixi': 'startDateStr',
        'SŞ Bitmə tarixi': 'endDateStr',
        'Qeydlər': 'descr',
      },
    };

  },
  methods: {
    handleEdit(id) {
      let routeData = this.$router.resolve({ path: "../accident/" + id });
      window.open(routeData.href, "_blank");
    },
    handleStatusView(id, type) {
      this.$refs["status"].view(id, type);
    },
    clickSearch() {
      this.filter.page = 1,
        this.item.dataexport = 0;
      this.getData();
    },
    getData() {
      this.loading = true;
      if (this.item.searchText == "") {
        this.item.searchText = null;
      }
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.pageSize = this.filter.pagesize;
      this.item.pageNumber = this.filter.page;
      GetCommAllAccidents(this.item).then((response) => {
        this.loading = false;
        if (response && response.data.data && response.data.data.length > 0) {
          this.displayData = response.data.data;
          this.totalRecords = response.data.data?.[0].totalRecords;
          // let num = this.data.length / 40
          // this.filter.pageSize = Math.round(num);
          // alert(this.filter.pageSize)
        }
        else {
          this.displayData = [];
          this.totalRecords = 0;
        }
      });
    },
    loadTime() {
      this.item.startDate = AddMonths(new Date(), -2);
      this.item.endDate = AddDays(new Date(), +1);
    },
    exportData() {
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      this.item.dataExport = 1;

      GetCommAllAccidents(this.item)
        .then((response) => {
          if (response.data?.data) {
            this.exportDataList = response.data.data;
          } else {
            this.exportDataList = [];
          }
        })
        .finally(() => {
          this.item.dataExport = 0;
          this.$nextTick(() => {
            this.$refs.excel.generate();
          });
        });
    },
    exportFile() {
      elTableExport(this.$refs.elTable, {
        fileName: "report",
        type: this.exportType,
        useFormatter: false,
      })
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t('Uğurlu_əməliyyat'),
          });
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: this.$t('Səhv_əməliyyat'),
          });
        });
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.filter.pagesize = val;
      this.getData();
    },
  },
  mounted() {

    this.loadTime();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>